import { warningPairs, safeHabits } from '@/mocks/warningBoard';

export default function WarningBoard() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-primary-950 text-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
        <div className="lg:col-span-3">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest uppercase text-primary-300 mb-3">
            <span className="w-6 h-px bg-primary-400"></span>
            对照表
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            套路长什么样，正确做法又是什么
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-200/90 leading-relaxed font-body max-w-2xl">
            避雷不是记住所有骗局，而是记住几个关键动作。左边是常见套路，右边是遇到时该做的事。
          </p>

          <ul className="mt-8 flex flex-col gap-3">
            {warningPairs.map((pair) => (
              <li
                key={pair.trap}
                className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 rounded-lg border border-background-100/15 bg-background-50/5 p-4"
              >
                <div className="flex items-start gap-3">
                  <span className="w-7 h-7 rounded-md bg-accent-500/25 text-accent-200 flex items-center justify-center text-sm shrink-0">
                    <i className="ri-close-line"></i>
                  </span>
                  <span className="text-sm text-background-100/90 font-body leading-relaxed">{pair.trap}</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 h-7 rounded-md bg-secondary-500/25 text-secondary-200 flex items-center justify-center text-sm shrink-0">
                    <i className="ri-check-line"></i>
                  </span>
                  <span className="text-sm text-background-50 font-body leading-relaxed">{pair.action}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="rounded-lg border border-secondary-500/30 bg-secondary-950/40 p-5 md:p-6 h-full">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                <i className="ri-shield-star-line"></i>
              </span>
              <h3 className="font-heading text-base font-bold text-background-50">值得养成的四个习惯</h3>
            </div>
            <ul className="space-y-4">
              {safeHabits.map((habit, index) => (
                <li key={habit} className="flex items-start gap-3">
                  <span className="font-heading text-sm font-bold text-secondary-300 w-5 shrink-0">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="text-sm text-background-100/90 font-body leading-relaxed">{habit}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 pt-5 border-t border-background-100/15 text-xs text-background-300/80 font-label leading-relaxed">
              这些习惯看起来普通，但能覆盖绝大多数消费争议中的举证与退款环节。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}